import React from 'react';
import ToastNotificationsWrapper
  from '@avtechsoftware/react-component-library/src/components/common/notifications/ToastNotificationsWrapper/ToastNotificationsWrapper';
import { useDispatch, useSelector } from 'react-redux';
import style from './ToastNotificationWrapperConnected.module.css';
import {
  dismissAllMessages,
  dismissMessage, pushSessionMessage, selectAllToastNotifications,
} from '../../../redux/slices/toastNotificationSlice/toastNotificationSlice';

function ToastNotificationWrapperConnected() {
  const dispatch = useDispatch();

  const connectedToastContext = {
    dismissMessage: (messageId) => dispatch(dismissMessage(messageId)),
    dismissAllMessages: () => dispatch(dismissAllMessages()),
    getAllMessages: () => useSelector(selectAllToastNotifications),
    pushSessionMessage: (
      level,
      title,
      body,
      durationInMillis,
    ) => dispatch(pushSessionMessage(
      {
        level, title, body, durationInMillis,
      },
    )),
  };
  /* istanbul ignore next */
  return (
    <div className={style.toasterTray}>
      <div className={style.toasterTrayBody}>
        <ToastNotificationsWrapper toastNotificationContext={connectedToastContext} />
      </div>
    </div>
  );
}

export { ToastNotificationWrapperConnected };
export default ToastNotificationWrapperConnected;
